<template>
  <section v-if="show" class="main-slider" :class="{ 'is-loading': isLoading }">
    <div class="main-slider__container" v-if="isLoading">
      <div class="main-slider__item">
        <a href="javascript:void(0);"></a>
      </div>
    </div>
    <div class="main-slider__container" v-else>
      <tiny-slider
        ref="tinyslider"
        v-bind="tinySliderOptions"
        v-if="banners && banners.length && !isLoading"
      >
        <div
          v-for="(banner, index) in banners"
          class="main-slider__item"
          :key="`main-slider-${index}`"
        >
          <a :href="banner.link" :title="banner.title">
            <img
              :src="banner.image"
              :alt="banner.title"
              :title="banner.title"
              fetchpriority="high"
              width="auto"
              height="auto"
            />
          </a>
        </div>
      </tiny-slider>
    </div>
  </section>
</template>
<style src="./MainSlider.scss" scoped></style>
<script>
import getBannerById from '@services/content/getBannerById';
import isMobile from '@helpers/isMobile';
import VueTinySlider from 'vue-tiny-slider';

export default {
  props: {
    preLoadedBanners: {
      type: Array,
      default: () => []
    },
    idDesktop: {
      type: Number,
      required: true
    },
    idMobile: {
      type: Number,
      required: true
    },
    hideOnStart: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'tiny-slider': VueTinySlider
  },
  computed: {
    show () {
      if (!this.hideOnStart) {
        return true;
      }
      if (this.hideOnStart && this.isLoading) {
        return false;
      }
      return true;
    },
    bannersIds () {
      return [this.idMobile, this.idDesktop];
    }
  },
  data: function () {
    return {
      isLoading: true,
      isMobile: true,
      banners: [],
      tinySliderOptions: {
        items: 1,
        autoplay: false,
        autoplayButtonOutput: false,
        lazyload: false,
        controls: true,
        controlsText: ['', ''],
        nav: false
      }
    };
  },
  methods: {
    checkViewport () {
      this.isMobile = isMobile();
    },
    fetch () {
      getBannerById(this.bannersIds[this.isMobile ? 0 : 1])
        .then(async (res) => {
          const banners = [];
          this.banners = banners.concat(res);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    init () {
      if (!this.preLoadedBanners.length) {
        this.fetch();
        return;
      }
      this.banners = JSON.parse(this.preLoadedBanners);
      this.isLoading = false;
    }
  },
  created () {
    this.checkViewport();
    this.init();
  }
};
</script>
